// extracted by mini-css-extract-plugin
module.exports = {"attendees":"styles_attendees__1AvCk","files":"styles_files__pd4E5","fileDisplay":"styles_fileDisplay__3dW0A"};